import { ICdItemLocation } from './ICdItemLocation';

export const sortByLocation = (a: { location?: ICdItemLocation }, b: { location?: ICdItemLocation }) => {
  const locA = a.location;
  const locB = b.location;
  // if neither item has a location, preserve current state
  if (locA === undefined && locB === undefined) {
    return 0;
  }
  // if locA does not have a location, sort it down
  if (locA === undefined) {
    return -1;
  }
  // if locB does not have a location, sort it down
  if (locB === undefined) {
    return 1;
  }
  // both items have a location, string compare descending
  return locA.section < locB.section ? -100 : locA.section > locB.section ? 100 : locA.line - locB.line;
};
